import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import HeroButton from "/app/src/components/HeroUi/Button";
import { useCallback } from "react";
import { IconBuilder } from "/app/src/components/icons/IconBuilder";
import { LogoBuilder } from "../icons/itempathLogo";

/**
 * NotFound component renders the custom 404 error page.
 *
 * @returns {JSX.Element} The JSX markup for the 404 error page.
 */
export default function NotFound() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  /**
   * Navigates the user to the dashboard page.
   *
   * @returns {void}
   */
  const goToDashboard = useCallback(() => {
    navigate("/dashboard");
  }, [navigate]);

  /**
   * Navigates the user back to the previous page.
   *
   * @returns {void}
   */
  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] h-[calc(100vh-116px)]">
      <div className="flex items-center justify-center px-[32px] py-[12px]">
        <LogoBuilder icon="ItemPathLogoWithText" theme="default" />
      </div>
      <div className="pt-xxlarge">
        <div className="text-neutral-charcoal font-semibold text-xlarge flex items-center justify-center ">
          {t("translation:404_page")}
        </div>
        <div className="text-[20px] flex flex-col items-center">
          <span>{t("translation:404_page_description")}</span>
          <span className="text-[#3B8BEA] text-[20px]">
            <ul className="list-disc">
              <li>
                <a
                  href="https://itempath.com/resource-central"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("translation:resource_center")}
                </a>
              </li>
              <li>
                <a
                  href="https://itempath.com/docs"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("translation:documentation")}
                </a>
              </li>
              <li>
                <a
                  href="https://itempath.com/courses"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("translation:courses")}
                </a>
              </li>
            </ul>
          </span>
          <div className="flex items-center">
            <HeroButton
              onClick={goBack}
              className="rounded-xxsmall mr-small"
              variant="bordered"
            >
              <IconBuilder icon="ChevronLeft" size={20} />
              {t("translation:go_back")}
            </HeroButton>
            <HeroButton
              color="primary"
              className="rounded-xxsmall"
              onClick={goToDashboard}
            >
              {t("translation:go_to_dashboard")}
            </HeroButton>
          </div>
        </div>
      </div>
    </div>
  );
}
